<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<h2 class="bd-title">Site Collection Settings</h2>
<p class="text-muted">
  <small><em>All fields are required unless specified optional</em></small>
</p>
<coso-select-input [control]="formGroup.controls.pattern" [inputText]="formText.pattern" [readonly]="isReadOnly$ | async"></coso-select-input>
@if (formGroup.controls.pattern.value == SiteCollectionRule.Period) {
<coso-select-input [control]="formGroup.controls.period" [inputText]="formText.period" [readonly]="isReadOnly$ | async"></coso-select-input>
<coso-select-input [control]="formGroup.controls.periodSource" [inputText]="formText.periodSource" [readonly]="isReadOnly$ | async"></coso-select-input>
} @if (formGroup.controls.pattern.value == SiteCollectionRule.Period && formGroup.controls.period.value == Period.Custom) {
<coso-text-input type="text" [control]="formGroup.controls.namePattern" [inputText]="formText.namePattern" [readonly]="isReadOnly$ | async"></coso-text-input>
}

<ng-template #namingRulePopover>
  <p>The structure or pattern used to get a site collection in SharePoint.</p>
  <p class="text-primary">The target site collection must exist in SharePoint.</p>
  <p class="text-primary">
    In case the <code class="text-primary">getSiteCollection()</code> function is implemented and returns a non-empty value, it will override the configuration for any other rule you select, because
    it has higher precedence.
  </p>
  <p><strong>None:</strong> This rule will get the first SharePoint instance in the configuration.</p>
  <p><strong>Period:</strong> This rule will get a site collection based on a specific time period (year, quarter, month, week, day or custom).</p>
  <p><strong>Per entity:</strong> This rule will get a site collection per entity (if one does not exist).</p>
  <p><strong>Custom script:</strong> This rule will get a site collection based on your LUA script. Implement <code class="text-primary">getSiteCollection()</code> function.</p>
</ng-template>

<ng-template #periodPopover>
  <p>The time period used to get the site collection.</p>
  <p><strong>Day and month:</strong> The format for this time period is {{ "{year}-{month}-{day}" }}.</p>
  <p><strong>Day:</strong> The format for this time period is {{ "{year}-{day}" }}.</p>
  <p><strong>Week:</strong> The format for this time period is {{ "{year}-W{week}" }}.</p>
  <p><strong>Month:</strong> The format for this time period is {{ "{year}-{month}" }}.</p>
  <p><strong>Quarter:</strong> The format for this time period is {{ "{year}-Q{quarter}" }}.</p>
  <p><strong>Year:</strong> The format for this time period is {{ "{year}" }}.</p>
  <p><strong>Custom:</strong> The format for this time period is very flexible.</p>
</ng-template>

<ng-template #periodSourcePopover>
  <p>The date used to get the site collection.</p>
  <p><strong>UTC Now (current date and time):</strong> The current date and time.</p>
  <p><strong>Create on (of D365 record):</strong> The Created-On attribute of the Dynamics 365 record.</p>
</ng-template>
